import { useMutation, useQueryClient } from '@tanstack/react-query';
import { markAllNotificationsAsRead } from '../../api/fetchers/notificationFetcher';

const useMarkAllNotificationsAsRead = () => {
    const queryClient = useQueryClient();

    const { mutateAsync, isLoading, isError, error } = useMutation({
        mutationFn: () => markAllNotificationsAsRead(),
        onSuccess: async () => {
            await queryClient.invalidateQueries(['notifications']);
            await queryClient.invalidateQueries(['notifications-unread-count']);
        },
    });

    return {
        mutateAsync,
        isPending: isLoading,
        isError,
        error,
    };
};

export default useMarkAllNotificationsAsRead;
